// extracted by mini-css-extract-plugin
export default {"container":"GQ7oqh","image":"mzWVZt","content":"AKXIbN"};